export const translations = {
  en: {
    mainHeading: "The Ultimate Genshin Impact Pity Tracker",
    mainIntro:
      "Track your wishes across all banners, predict your 50/50s with the exclusive Capturing Radiance system, manage your character collection, and plan your next 5-star pull. 100% private, ad-free, and secure.",
    title: "Genshin Impact Pity Tracker",
    subtitle: "Track your wishes, manage your collection, and plan your pulls!",
    settings: "Settings",
    language: "Language",
    theme: "Theme",
    dataManagement: "Data Management",
    exportButton: "Export Data (.json)",
    importButton: "Import Data (.json)",
    resourceManagement: "Resource Management",
    primogems: "Primogems",
    intertwinedFates: "Intertwined Fates",
    acquaintFates: "Acquaint Fates",
    genesisCrystals: "Genesis Crystals",
    starglitter: "Starglitter",
    stardustReminder:
      "Remember the monthly shop reset for more Fates from Stardust!",
    buyWithGlitter: "Buy 1 with 5 Starglitter",
    notEnoughStarglitter: "Not enough Starglitter!",
    useGenesisCrystals: "Use Crystals for Planning",
    totalWishes: "Available Wishes",
    eventWeapon: "Event/Weapon/Chronicled",
    standard: "Standard",
    characterBanner: "Character Event Banner",
    moveBatchToChar2: "Wrong Banner? Move to Char 2",
    moveBatchToChar1: "Wrong Banner? Move to Char 1",
    moveBatchTooltip: "Move last pull/batch to the other banner",
    pity5starLabel: "5★ Pity (max. 90)",
    pity5starLabelWeapon: "5★ Pity (max. 80)",
    chanceLabel: "Chance",
    status5050: "50/50",
    statusGuaranteed: "Guaranteed!",
    pity4starLabel: "4★ Pity (max. 10)",
    add1Wish: "+1 (★★★ only)",
    add10Wishes: "10-Pull",
    log4star: "Log single ★★★★",
    log5star: "Log single ★★★★★",
    toggleGuarantee: "Toggle guarantee manually:",
    toggle: "Toggle",
    resetBanner: "Reset Banner",
    historyAndStats: "History & Statistics",
    filterAll: "All",
    filter5star: "5★ Only",
    filter4star: "4★ Only",
    weaponBanner: "Epitome Invocation",
    standardBanner: "Wanderlust Invocation",
    footer1: "Made with ❤️ for a fellow Traveler. Good luck on your wishes!",
    footer2:
      "Genshin Impact™ is a trademark of Cognosphere PTE. LTD. (HoYoverse). This is an unofficial, non-commercial fan-made tool. All game assets, icons, and characters are the property of HoYoverse. This site is not affiliated with or endorsed by HoYoverse. Image assets are sourced from the Genshin Impact Wiki.",
    confirmTitle: "Are you sure?",
    confirmYes: "Yes, confirm",
    cancel: "Cancel",
    itemReceived: "Item Received!",
    whatDidYouGet: "Who or what did you get?",
    save: "Save",
    tenPullTitle: "Log 10-Pull Results",
    tenPullSubtitle:
      "Add all 4-star and 5-star items from your 10-pull. The rest are assumed to be 3-stars.",
    addPullEntry: "+ Add 4/5-Star Pull",
    saveTenPull: "Save 10-Pull",
    confirmResetText:
      "Do you really want to reset the {bannerName} banner? All data for this banner will be lost.",
    confirmDeleteText:
      "Do you really want to delete this history entry? This cannot be undone.",
    noMatchingPulls: "No matching pulls in history.",
    avgPity: "Avg. 5★ Pity:",
    winRate5050: "50/50 Win Rate:",
    pullsAt: "at pity {pity}",
    outcomeWin: "(Win)",
    outcomeCapturingRadiance: "(Capturing Radiance)",
    outcomeLoss: "(Loss)",
    outcomeGuaranteed: "(Guaranteed)",
    outcomeStandard: "(Standard)",
    enterNamePrompt: "Please enter a name.",
    itemNotFound:
      "Item '{name}' not found in the database. Please check the spelling.",
    invalidItemForBanner:
      "Invalid item '{name}' for a {rarity}-star pull on this banner.",
    dataImportSuccess: "Data imported successfully!",
    dataImportError: "Error importing file: ",
    invalidFileFormat: "Invalid file format.",
    noResources: "Not enough wishes or primogems available!",
    duplicatePullNumber: "Each pull number can only be used once per 10-pull.",
    invalidPullNumber:
      "Please enter a valid pull number (1-10) for all entries.",
    guaranteed5starMissing:
      "A 5-star was guaranteed in this 10-pull but was not logged. Please add it.",
    guaranteed4starMissing:
      "A 4-star or better was guaranteed in this 10-pull but was not logged. Please add it.",
    pity5starExceeded:
      "Invalid entry. A 5-star must be pulled at or before reaching max pity.",
    pity4starExceeded:
      "Invalid entry. A 4-star or better must be pulled at or before the 10th pull in a pity cycle.",
    guaranteed4starTooltip:
      "Guaranteed 4-star! Please log it with the buttons below.",
    guaranteed5starTooltip:
      "Guaranteed 5-star! Please log it with the buttons below.",
    total: "Total",
    fates: "Fates",
    fromPrimos: "from Primos",
    wishPriority: "Wish Priority:",
    fatesFirst: "Fates First",
    primosFirst: "Primos First",
    goalPlanner: "Goal Planner",
    plannerBanner: "Banner",
    plannerGoal: "Goal",
    plannerNext5: "Next 5-Star",
    plannerGuaranteed5: "Guaranteed 5-Star",
    plannerWishesNeeded: "Wishes needed (worst case):",
    plannerPrimosNeeded: "Equals to:",
    plannerShortfall: "Your shortfall:",
    wishes: "wishes",
    tabResources: "Resources & Plan",
    totalPulls: "Total Pulls:",
    avg4starPity: "Avg. 4★ Pity:",
    luckiestPull: "Luckiest 5★:",
    unluckiestPull: "Unluckiest 5★:",
    total5stars: "Total 5★:",
    total4stars: "Total 4★:",
    standard5starRatio: "5★ Type (Char/Wep):",
    tabChronicled: "Chronicled",
    chronicledBanner: "Chronicled Wish",
    featuredItem: "Featured Item:",
    featuredItems: "Featured Items:",
    featured5StarItems: "Featured 5★ Items",
    featured4StarItems: "Featured 4★ Items",
    yourCourse: "Your Course:",
    confirmSetCourse:
      "Changing your course will reset your guarantee (if you have one). Are you sure?",
    winRatePath: "Path Win Rate:",
    dailyIncome: "Daily Income",
    welkinMoon: "Welkin Moon",
    battlePass: "Battle Pass",
    estimatedDays: "Estimated days to goal:",
    imprint: "Imprint",
    privacyPolicy: "Privacy Policy",
    howToUse: "How to use",
    close: "Close",
    imprintOwner: "Owner & Contact:",
    imprintContact: "Contact:",
    imprintEmail: "Email",
    ourPromiseTitle: "Our Promise to You",
    promise1:
      "✔️ <strong>100% Private & Offline:</strong> No servers, no accounts, no data collection. Everything is saved only on your device.",
    promise2:
      "✔️ <strong>Zero Annoyances:</strong> No ads, no cookie banners, no trackers. Just a clean, fast tool that respects you.",
    promise3:
      "✔️ <strong>More Than a Counter:</strong> The only tracker with an integrated <strong>Capturing Radiance</strong> system, a full <strong>Collection Manager</strong>, and even a <strong>Minigame</strong>!",
    privacyIntro:
      "Your privacy is important. This page explains what data is stored and where.",
    privacyDataProcessing: "Data Processing",
    privacyDataProcessingText:
      "All data you enter into this Pity Tracker (your pity counts, wish history, resources, etc.) is stored exclusively in your browser's own local storage (`localStorage`). This data never leaves your device and is not sent to any server. The website operator has no access to your data. If you clear your browser cache or use a different browser/device, this data will not be available.",
    privacyContact: "Contact",
    privacyContactText:
      "If you have any questions about privacy, you can contact the website owner via the email address provided in the imprint.",
    howtoTitle: "Welcome, Traveler!",
    howtoIntro:
      "Your journey to mastering the gacha starts here. This guide will show you how to get the most out of your Pity Tracker.",
    howtoPrivacyTitle: "🔒 Your Data, Your Device. Period.",
    howtoPrivacyText:
      "Everything you enter is saved ONLY in your browser. This app works completely offline and has no server. It's 100% local, private, and secure.",
    howtoStepsTitle: "Your Path in 4 Quick Steps",
    howtoStep1Title: "💰 Sync Your Arsenal",
    howtoStep1Text:
      "First, visit the 'Resources & Plan' tab to enter your <strong>Primogems</strong> and <strong>Fates</strong>. If you're not new, use the 'Set Pity' fields on each banner to sync your current progress from in-game.",
    howtoStep2Title: "✨ Track Every Wish",
    howtoStep2Text:
      "In the 'Banners' tab, use the '+1' or '10-Pull' buttons to track wishes. When you get a 4★ or 5★, use the 'Log' buttons to record it – this automatically resets your pity and adds the item to your collection.",
    howtoStep3Title: "📚 Build Your Collection & Analyze Your Fortune",
    howtoStep3Text:
      "Go to the 'Profile' tab to see your <strong>Collection</strong> grow with every pull! Manage constellations, check refinements, and click any item to open the built-in <strong>Teyvat Wiki</strong>. Then, check your 'Fortune Analysis' to see your personal <strong>Luck Score</strong>.",
    howtoStep4Title: "💾 Safeguard Your History",
    howtoStep4Text:
      "Your data is precious. Use the 'Export Data' function in the Settings (⚙️) to create a manual backup. For effortless syncing across devices, you can also **optionally connect your Google Drive account** for secure cloud saves.",
    howtoEnjoy: "Happy wishing, Traveler!",
    howtoButton: "Let's Get Started!",
    versionInfo: "Currently supports Genshin Impact Version {version}",
    changelog: "Changelog",
    changelogTitle: "What's New",
    changelogRefreshTitle: "Update Notice",
    changelogRefreshDesktop:
      "To ensure you have the latest version, please perform a hard refresh (Ctrl + F5).",
    changelogRefreshMobile:
      "On mobile, you may need to clear your browser's cache for this site in the settings.",
    backupReminderTitle: "IMPORTANT: Backup Your Data!",
    backupReminderText:
      "Before performing a hard refresh or clear your cache, please use the 'Export Data' function in the settings (⚙️ icon) to create a backup file of your wish history. This prevents any risk of data loss.",
    chartPityHistory: "Pity History",
    chartDistribution: "Distribution",
    chartTypeRatio: "Type Ratio",
    createShareImage: "Create Share Image",
    shareTitle: "Share Your Stats",
    shareLoader: "Generating image, please wait...",
    shareDownload: "Download Image",
    luckiest4star: "Luckiest 4★:",
    unluckiest4star: "Unluckiest 4★:",
    ratio4star: "4★ Ratio (Char/Wep):",
    weaponRateUpLabel: "Rate Up 75%",
    rateUpLabel: "Rate Up 50%",
    banner_ineffa: "Astral Actuation",
    banner_citlali: "Starry Night's Whispers",
    banner_chasca: "Piercing Shot's Crimson Wake",
    banner_mualani: "Sharktacular Surfari",
    banner_flins: "The Lone Light Knocks at Night",
    banner_yelan: "Discerner of Enigmas",
    banner_lauma: "Moonsong of the Groves",
    banner_nahida: "Moongrass' Enlightenment",
    banner_nefer: "Temptation of the Crimson Sands",
    banner_furina: "Chanson of Many Waters",
    banner_arlecchino: "The Hearth's Ashen Shadow",
    banner_zhongli: "Gentry of Hermitage",
    banner_durin: "Rubedo, of White Stone Born",
    banner_venti: "Ballad in Goblets",
    banner_varesa: "Cornucopia of Contention",
    banner_xilonen: "Forgefire's Blessing",
    banner_zibai: "Harmonius Abundance",
    banner_columbina: "Somnias a Luna",
    banner_neuvillette: "Decree of the Deeps",
    banner_skirk: "Void Star's Advent",
    banner_escoffier: "La Chanson Cerise",
    banner_varka: "The Northerly Wind's Song of Triumph",
    banner_linnea: "Ya-hoho! Compendium",
    banner_nicole: "",
    banner_lohen: "",
    banner_mauvika: "",
    banner_prune: "",
    characterBannerPhase1: (name) => `Event Wish (${name})`,
    characterBannerPhase2: (name) => `Event Wish (${name})`,
    nextBannerButton: "Next Banners",
    upcomingBannersTitle: "Upcoming Banners",
    bannerEndsIn: "Ends in:",
    bannerEnded: "Banner has ended",
    sectionTitle: "Your Ultimate Genshin Impact Pity Tracker & Wish Counter",
    whatIsPityTitle: "What is Pity? Your Guide to the Genshin Wish Counter",
    whatIsPityText1:
      'In Genshin Impact, the "Pity System" is a crucial gacha mechanic ensuring you receive 4-star and 5-star items after a set number of wishes. Each time you wish on a banner and don\'t get a high-rarity item, your "pity" for that banner increases. This tool acts as your personal <strong>Genshin Impact wish counter</strong>, automating all the complex rules for you.',
    whatIsPityText2:
      'The pity count resets to zero for a specific rarity once you obtain an item of that rarity. For 5-star characters, a guaranteed pull occurs at 90 wishes (with a "soft pity" phase starting around 74), and for the weapon banner, it\'s 80 wishes. For 4-star items, the pity is capped at 10. Never miss a guaranteed 5-star again by using this precise <strong>Genshin pity counter</strong> for every single wish!',
    pityGuideExtra:
      'This <strong>Genshin Wish Tracker</strong> helps you document this process flawlessly. Every single wish is counted, so you know exactly when you enter the "soft pity" zone—the range where the probability of pulling a 5-star character or weapon increases significantly. Forget inaccurate guesswork; with this tool, you have a precise <strong>Genshin Impact counter</strong> for your gacha journey.',
    howToUseTitle: "How to Use This Genshin Wish Tracker",
    howToUseStep1:
      "<strong>1. Set Up Your Resources:</strong> Navigate to the 'Resources & Plan' tab. Input your current Primogems, Fates, and Starglitter to get a clear overview of your total available wishes.",
    howToUseStep2:
      "<strong>2. Sync Your Pity Count:</strong> If you're new, check your in-game history and use the \"Set Pity\" fields on each banner in the 'Banners' tab to quickly sync your progress. This one-time setup ensures your <strong>pity count</strong> starts correctly.",
    howToUseStep3:
      "<strong>3. Log Your Wishes:</strong> Use the '+1' or '10-Pull' buttons to add wishes. When you get a 4-star or 5-star item, use the dedicated 'Log' buttons. The tool automatically resets your pity and adds the new item to your personal collection.",
    howToUseStep4:
      "<strong>4. Manage Multiple Accounts:</strong> Go to Settings (⚙️) -> Data Management. Here you can add, rename, and switch between multiple accounts. Each account has its own completely separate data, and a single click on 'Export Data' or 'Save to Drive' backs up all of them at once.",
    howToUseStep5:
      "<strong>5. Manage Your Character & Weapon Collection:</strong> Go to the 'Profile' tab and select 'My Collection'. Here you can see every character and weapon you've pulled. Activate pending constellations for characters or refine duplicate weapons with a single click.",
    howToUseStep6:
      "<strong>6. Analyze Your Gacha Luck & Plan Ahead:</strong> In the 'Profile' tab, switch to 'Fortune Analysis' to see your personal Luck Score and detailed stats. Then, use the 'Goal Planner' in the 'Resources' tab to calculate how long it will take to get your next desired 5-star.",
    bannerRulesTitle: "Genshin Banner Rules Explained",
    bannerRulesIntro:
      "Genshin Impact's pity system has specific rules for each banner type. Our <strong>pity counter</strong> handles these automatically, but here’s a detailed explanation:",
    bannerRulesCharTitle: "Character Banner (The 50/50 System Explained):",
    bannerRulesCharText:
      "When you pull a 5-star character, there's a 50% chance it's the featured rate-up character. If you lose this '50/50' and get a standard character (like Diluc, Jean, etc.), your fate is sealed: your next 5-star pull on any character event banner is <strong>100% guaranteed</strong> to be the featured character. This is the most critical mechanic our <strong>Genshin tracker</strong> manages for you.",
    bannerRulesWeaponTitle: "Weapon Banner (Epitomized Path Explained):",
    bannerRulesWeaponText:
      "This banner features a 75% chance to get one of the two featured 5-star weapons. To target a specific one, you use 'Epitomized Path' to chart a course. If you receive a 5-star weapon that is not your chosen one, you gain <strong>1 Fate Point</strong>. With 1 Fate Point, your next 5-star is <strong>100% guaranteed</strong> to be the one you charted a course for.",
    bannerRulesChronicledTitle: "Chronicled Wish (Designated Item Guarantee):",
    bannerRulesChronicledText:
      "This special banner lets you chart a course for a 5-star character OR weapon from a large pool. If you pull a 5-star that isn't your designated choice, you get <strong>1 Fate Point</strong>, and the next 5-star is <strong>guaranteed</strong> to be your course item. Pity resets to zero upon receiving any 5-star.",
    wikiTitle: "Integrated Teyvat Wiki for Builds & Materials",
    wikiIntro:
      "This tracker is more than just a counter—it's your strategic companion. Click on a character's portrait on the banners, in your history, or directly from your <strong>Collection</strong> to open a detailed information panel.",
    wikiText:
      "Inside, you'll find everything you need for pre-farming and planning. Even better, you can click on materials, weapons, or teammate icons <strong>within the panel</strong> to instantly see their details without leaving the page.",
    wikiOutro:
      "This feature makes planning for your next most-wanted character easier than ever and is a unique hallmark of this <strong>Genshin Impact wish counter</strong>.",
    privacyTitle: "Our Privacy Promise: 100% Local, 100% Yours",
    privacyText1:
      "This tracker was built on a simple philosophy: your data belongs to you. <strong>There is no server. There are no accounts.</strong> Nothing you enter ever leaves your device. We cannot see your pity, your wish history, or any other information. This tool works completely offline.",
    privacyText2:
      'All data is saved in your browser\'s "Local Storage". This makes the app extremely fast, but it also means that clearing your browser\'s cache or site data will permanently delete your history. <strong>Please use the "Export Data" function in the Settings regularly to create backups!</strong>',
    privacyText3:
      "For convenience, you have the <strong>optional</strong> ability to sync your data using your own Google Drive account. Even then, this app only gets permission to access the single file it creates. You are always in full control.",
    privacyText4:
      "No ads. No cookie banners. No tracking. Just a tool built by a fan, for fans.",
    settingsTabGeneral: "General",
    settingsTabData: "Data",
    dataManagementDesc:
      "Save your wish history to a file or import a previous backup.",
    settingsTabAchievements: "Achievements",
    tabBanners: "Banners",
    tabProfile: "Profile",
    profileTitle: "Traveler's Fortune Analysis",
    profileNoData: "Track more wishes to unlock your profile analysis!",
    profileLuckScore: "Luck Score",
    profileAvgPity5: "Avg. 5★ Pity",
    profileWinRate5050: "50/50 Win Rate",
    profileElementalAffinity: "Elemental Affinity",
    profileFortuneCookie: "Fortune Cookie's Insight",
    profileWeaponAffinity: "Weapon Affinity",
    profileAvgPity4: "Avg. 4★ Pity",
    background: "Background",
    bgIcons: "Icons",
    bgStars: "Stars",
    bgOff: "Off",
    minigameRestart: "Restart Game",
    minigameResetHighscore: "Reset Highscore",
    confirmResetHighscoreText:
      "Are you sure you want to reset your highscore? This cannot be undone.",
    audioSettings: "Audio Settings",
    confirmDeleteInventoryChar: (name) =>
      `Are you sure you want to permanently delete ${name} from your collection? This cannot be undone.`,
    confirmDeleteInventoryWeapon: (name) =>
      `Are you sure you want to permanently delete this copy of ${name} from your collection? This cannot be undone.`,
    tabGuide: "Guide",
    googleDriveSyncDesc:
      "For effortless syncing across devices and secure cloud backups, you can optionally connect your Google Account. The app will only ever have permission to access its own data file.",
    crTitle: "Capturing Radiance: Your Bad Luck Protection",
    crIntro:
      'Capturing Radiance (CR) is a benevolent hidden system designed by HoYoverse to prevent extreme bad luck streaks when losing multiple 50/50s in a row. It is a special, vibrant wish animation that signifies a "forced" win. This tracker helps you monitor the invisible counter behind this safety net, known as the <strong>C-State</strong>.',
    crHowItWorksTitle: "How the C-State Counter Works:",
    crHowItWorksText:
      "The C-State changes with your 50/50 outcomes. Losing a 50/50 increases it by 1 (up to a max of 3). A normal 50/50 win decreases it by 1. A Capturing Radiance win resets it directly to 1.",
    crStateMeaningsTitle: "What the C-State in Your Tracker Means:",
    crState01:
      "<strong>C-State 0 or 1:</strong> Your next 50/50 is a standard roll.",
    crState2:
      "<strong>C-State 2:</strong> You have a slightly boosted chance for your next 50/50 win to be a Capturing Radiance.",
    crState3:
      "<strong>C-State 3:</strong> Your next 50/50 is <strong>guaranteed to be a win</strong> and will trigger the Capturing Radiance animation, even if you were destined to lose! This is the ultimate bad luck protection.",
    crHowToUseTrackerTitle: "How the Tracker Helps You:",
    crHowToUseTrackerText:
      'When you start, the tracker estimates your C-State based on your history (indicated by a "?"). After you win a 50/50, the tracker will ask if it was a "Capturing Radiance" win. Your answer will precisely calibrate the C-State, removing the question mark and making all future predictions accurate. You can also set your state manually in the Settings if you already know it.',
    manageGoals: "Manage Goals",
    saveGoals: "Save Goals & Recalculate",
    plannerGuideTitle: "How the Goal Planner Scenarios Are Calculated",
    plannerGuideIntro:
      "The Goal Planner provides three different estimates to help you plan your wishes effectively. Here's what each scenario means:",
    plannerGuideLuckyTitle: "LUCKY CASE",
    plannerGuideLuckyText:
      "This is your dream scenario. It assumes you win every 50/50 and get your 5-star character or weapon very early, well before soft pity (at an average of 35 wishes). While possible, don't rely on this outcome!",
    plannerGuideAverageTitle: "AVERAGE CASE",
    plannerGuideAverageText:
      "This is the most realistic estimate, based on large-scale community data. It uses the true statistical averages:",
    plannerGuideAveragePity:
      "A guaranteed 5-star takes about <strong>63 wishes</strong> on average (due to soft pity).",
    plannerGuideAverage5050:
      "A non-guaranteed character takes about <strong>93 wishes</strong> on average (this number already includes the statistical chance of losing the 50/50).",
    plannerGuideAverageCR:
      "It also takes your current <strong>Capturing Radiance (C-State)</strong> into account. If you are at C-State 3, the planner knows your next 50/50 is a guaranteed win and adjusts the calculation accordingly!",
    plannerGuideWorstTitle: "WORST CASE",
    plannerGuideWorstText:
      "This is your safety net. It assumes you lose every single chance:",
    plannerGuideWorstPity:
      "You pull until Hard Pity every time (90 for characters, 80 for weapons).",
    plannerGuideWorst5050:
      "You lose every 50/50 and every 75/25, requiring you to pull a second time to get your guaranteed item.",
    plannerGuideWorstWhy:
      "<strong>Why isn't the number perfectly round?</strong> The calculation subtracts your current pity progress from the cost of the <em>very first</em> pull in the sequence, giving you a 'discount' for the wishes you've already made.",
    plannerInventoryNote:
      "Note: The calculation takes your existing character constellations and weapon refinements from 'My Collection' into account.",
    chronicledInactiveTitle: "Currently Unavailable",
    chronicledInactiveText:
      "The Chronicled Wish banner is not active in the current Phase.",
    starglitterEquivalent: "Equals {count} Fates",
    genesisEquivalent: "Equals {count} Fates",
    primogemEquivalent: "Equals {count} Fates",
  },
  de: {
    mainHeading: "Der ultimative Genshin Impact Pity Tracker",
    mainIntro:
      "Verfolge deine Gebete auf allen Bannern, sage deine 50/50s mit dem exklusiven 'Gefangener Glanz'-System voraus, verwalte deine Figurensammlung und plane deinen nächsten 5-Sterne-Zug. 100% privat, werbefrei und sicher.",
    title: "Genshin Impact Pity Tracker",
    subtitle: "Verfolge Gebete, verwalte deine Sammlung und plane deine Züge!",
    settings: "Einstellungen",
    language: "Sprache",
    theme: "Thema",
    dataManagement: "Datenverwaltung",
    exportButton: "Daten exportieren (.json)",
    importButton: "Daten importieren (.json)",
    resourceManagement: "Ressourcen-Verwaltung",
    primogems: "Urgestein",
    intertwinedFates: "Verwobenes Schicksal",
    acquaintFates: "Vorbestimmtes Schicksal",
    genesisCrystals: "Schöpfungskristalle",
    starglitter: "Sternenglanz",
    stardustReminder:
      "Denk an den monatlichen Shop-Reset für mehr Schicksal aus Sternenstaub!",
    buyWithGlitter: "Kaufe 1 für 5 Sternenglanz",
    notEnoughStarglitter: "Nicht genug Sternenglanz!",
    useGenesisCrystals: "Kristalle für Planung nutzen",
    totalWishes: "Verfügbare Gebete",
    eventWeapon: "Aktion/Waffe/Kronik",
    standard: "Standard",
    characterBanner: "Aktionsfigurenbanner",
    moveBatchToChar2: "Falsches Banner? Zu Char 2",
    moveBatchToChar1: "Falsches Banner? Zu Char 1",
    moveBatchTooltip: "Verschiebe letzten Zug/Batch zum anderen Banner",
    pity5starLabel: "5★ Pity (max. 90)",
    pity5starLabelWeapon: "5★ Pity (max. 80)",
    chanceLabel: "Chance",
    status5050: "50/50",
    statusGuaranteed: "Garantiert!",
    pity4starLabel: "4★ Pity (max. 10)",
    add1Wish: "+1 (nur ★★★)",
    add10Wishes: "10er-Pull",
    log4star: "Einzelnen ★★★★ loggen",
    log5star: "Einzelnen ★★★★★ loggen",
    toggleGuarantee: "Garantie manuell ändern:",
    toggle: "Umschalten",
    resetBanner: "Banner zurücksetzen",
    historyAndStats: "Verlauf & Statistiken",
    filterAll: "Alle",
    filter5star: "Nur 5★",
    filter4star: "Nur 4★",
    weaponBanner: "Göttliches Werk",
    standardBanner: "Wanderlust",
    footer1:
      "Erstellt mit ❤️ für einen Mit-Reisenden. Viel Glück bei deinen Gebeten!",
    footer2:
      "Genshin Impact™ ist eine Marke von Cognosphere PTE. LTD. (HoYoverse). Dies ist ein inoffizielles, nicht-kommerzielles Fan-Tool. Alle Spielinhalte, Icons und Charaktere sind Eigentum von HoYoverse. Diese Seite steht in keiner Verbindung zu HoYoverse und wird nicht von HoYoverse unterstützt. Bildmaterialien stammen aus dem Genshin Impact Wiki.",
    confirmYes: "Ja, bestätigen",
    cancel: "Abbrechen",
    itemReceived: "Gegenstand erhalten!",
    whatDidYouGet: "Wen oder was hast du bekommen?",
    save: "Speichern",
    tenPullTitle: "10er-Pull Ergebnis eintragen",
    tenPullSubtitle:
      "Füge alle 4- und 5-Sterne-Ziehungen aus deinem 10er-Pull hinzu. Die restlichen werden als 3-Sterne angenommen.",
    addPullEntry: "4/5-Sterne-Zug hinzufügen +",
    saveTenPull: "10er-Pull speichern",
    confirmResetText:
      "Möchtest du das {bannerName}-Banner wirklich zurücksetzen? Alle Daten für dieses Banner gehen verloren.",
    confirmDeleteText:
      "Möchtest du diesen Verlaufseintrag wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
    noMatchingPulls: "Keine passenden Ziehungen im Verlauf.",
    avgPity: "Durchschn. 5★ Pity:",
    winRate5050: "50/50 Gewinnrate:",
    pullsAt: "bei Pity {pity}",
    outcomeWin: "(Gewinn)",
    outcomeCapturingRadiance: "(Gefangener Glanz)",
    outcomeLoss: "(Verlust)",
    outcomeGuaranteed: "(Garantiert)",
    outcomeStandard: "(Standard)",
    enterNamePrompt: "Bitte gib einen Namen ein.",
    itemNotFound:
      "Gegenstand '{name}' nicht in der Datenbank gefunden. Bitte Schreibweise prüfen.",
    invalidItemForBanner:
      "Ungültiger Gegenstand '{name}' für eine {rarity}-Sterne-Ziehung auf diesem Banner.",
    dataImportSuccess: "Daten erfolgreich importiert!",
    dataImportError: "Fehler beim Importieren der Datei: ",
    invalidFileFormat: "Ungültiges Dateiformat.",
    noResources: "Nicht genügend Gebete oder Urgestein vorhanden!",
    duplicatePullNumber:
      "Jede Pull-Nummer kann nur einmal pro 10er-Pull vergeben werden.",
    invalidPullNumber:
      "Bitte gib eine gültige Pull-Nummer (1-10) für alle Einträge an.",
    guaranteed5starMissing:
      "Ein 5-Sterne-Zug war in diesem 10er-Pull garantiert, wurde aber nicht eingetragen. Bitte füge ihn hinzu.",
    guaranteed4starMissing:
      "Ein 4-Sterne-Zug (oder besser) war in diesem 10er-Pull garantiert, wurde aber nicht eingetragen. Bitte füge ihn hinzu.",
    pity5starExceeded:
      "Ungültige Eingabe. Ein 5-Sterne-Zug muss spätestens beim Erreichen des maximalen Pity erfolgen.",
    pity4starExceeded:
      "Ungültige Eingabe. Ein 4-Sterne-Zug (oder besser) muss spätestens beim 10. Zug eines Pity-Zyklus erfolgen.",
    guaranteed4starTooltip:
      "Garantierter 4-Sterne! Bitte mit den Buttons unten loggen.",
    guaranteed5starTooltip:
      "Garantierter 5-Sterne! Bitte mit den Buttons unten loggen.",
    total: "Gesamt",
    fates: "Gebete",
    fromPrimos: "aus Urgestein",
    wishPriority: "Gebets-Priorität:",
    fatesFirst: "Gebete zuerst",
    primosFirst: "Urgestein zuerst",
    goalPlanner: "Ziel-Planer",
    plannerBanner: "Banner",
    plannerGoal: "Ziel",
    plannerNext5: "Nächster 5-Sterne",
    plannerGuaranteed5: "Garantierter 5-Sterne",
    plannerWishesNeeded: "Benötigte Gebete (Maximalfall):",
    plannerPrimosNeeded: "Entspricht:",
    plannerShortfall: "Dir fehlen:",
    wishes: "Gebete",
    tabResources: "Ressourcen & Planer",
    totalPulls: "Ziehungen gesamt:",
    avg4starPity: "Durchschn. 4★ Pity:",
    luckiestPull: "Bester 5★ Zug:",
    unluckiestPull: "Schlechtester 5★ Zug:",
    total5stars: "5★ Gesamt:",
    total4stars: "4★ Gesamt:",
    standard5starRatio: "5★ Typ (Figur/Waffe):",
    tabChronicled: "Kronik",
    chronicledBanner: "Kronikgebet",
    featuredItem: "Vorgestelltes Item:",
    featuredItems: "Vorgestellte Items:",
    featured5StarItems: "Vorgestellte 5★ Items",
    featured4StarItems: "Vorgestellte 4★ Items",
    yourCourse: "Dein Kurs:",
    confirmSetCourse:
      "Wenn du deinen Kurs änderst, wird deine Garantie (falls vorhanden) zurückgesetzt. Bist du sicher?",
    winRatePath: "Kurs-Gewinnrate:",
    dailyIncome: "Tägliche Einnahmen",
    welkinMoon: "Mondsegen",
    battlePass: "Erlebnispass",
    estimatedDays: "Geschätzte Tage zum Ziel:",
    imprint: "Impressum",
    privacyPolicy: "Datenschutzerklärung",
    howToUse: "Anleitung",
    close: "Schließen",
    imprintOwner: "Inhaber & Kontakt:",
    imprintContact: "Kontakt:",
    imprintEmail: "E-Mail",
    ourPromiseTitle: "Unser Versprechen an dich",
    promise1:
      "✔️ <strong>100% Privat & Offline:</strong> Keine Server, keine Konten, keine Datensammlung. Alles wird nur auf deinem Gerät gespeichert.",
    promise2:
      "✔️ <strong>Null Ablenkungen:</strong> Keine Werbung, keine Cookie-Banner, keine Tracker. Nur ein sauberes, schnelles Tool, das dich respektiert.",
    promise3:
      "✔️ <strong>Mehr als ein Zähler:</strong> Der einzige Tracker mit integriertem <strong>Gefangener Glanz</strong>-System, einem vollständigen <strong>Sammlungs-Manager</strong> und sogar einem <strong>Minispiel</strong>!",
    privacyIntro:
      "Deine Privatsphäre ist wichtig. Hier wird erklärt, welche Daten wo gespeichert werden.",
    privacyDataProcessing: "Datenverarbeitung",
    privacyDataProcessingText:
      "Alle Daten, die du in diesen Pity Tracker eingibst (deine Pity-Stände, Gebetsverlauf, Ressourcen etc.), werden ausschließlich im lokalen Speicher (`localStorage`) deines Browsers gespeichert. Diese Daten verlassen niemals dein Gerät und werden an keinen Server gesendet. Der Betreiber der Webseite hat keinen Zugriff auf deine Daten. Wenn du deinen Browser-Cache löschst oder einen anderen Browser/ein anderes Gerät verwendest, sind diese Daten nicht verfügbar.",
    privacyContact: "Kontakt",
    privacyContactText:
      "Bei Fragen zum Datenschutz kannst du den Betreiber der Webseite über die im Impressum angegebene E-Mail-Adresse kontaktieren.",
    howtoTitle: "Willkommen, Reisender!",
    howtoIntro:
      "Deine Reise zur Meisterschaft über das Gacha-System beginnt hier. Dieser Guide zeigt dir, wie du das Beste aus deinem Pity Tracker herausholst.",
    howtoPrivacyTitle: "🔒 Deine Daten, dein Gerät. Immer.",
    howtoPrivacyText:
      "Alles, was du eingibst, wird NUR in deinem Browser gespeichert. Diese App funktioniert komplett offline und hat keinen Server. Es ist 100 % lokal, privat und sicher.",
    howtoStepsTitle: "Dein Pfad in 4 schnellen Schritten",
    howtoStep1Title: "💰 Synchronisiere dein Arsenal",
    howtoStep1Text:
      "Besuche zuerst den Tab 'Ressourcen & Planer', um dein <strong>Urgestein</strong> und <strong>Schicksal</strong> einzutragen. Wenn du nicht bei Null anfängst, nutze die 'Pity setzen'-Felder auf jedem Banner, um deinen Fortschritt aus dem Spiel zu synchronisieren.",
    howtoStep2Title: "✨ Verfolge jedes Gebet",
    howtoStep2Text:
      "Nutze im 'Banner'-Tab die '+1' oder '10er-Pull'-Buttons, um Gebete zu zählen. Wenn du einen 4★ oder 5★ erhältst, nutze die 'Loggen'-Buttons zur Aufzeichnung – das setzt deine Pity automatisch zurück und fügt das Item deiner Sammlung hinzu.",
    howtoStep3Title: "📚 Baue deine Sammlung auf & analysiere dein Glück",
    howtoStep3Text:
      "Gehe zum 'Profil'-Tab, um deine <strong>Sammlung</strong> mit jedem Zug wachsen zu sehen! Verwalte Sternbilder, prüfe Verfeinerungen und klicke auf ein Item, um das eingebaute <strong>Teyvat-Wiki</strong> zu öffnen. Wechsle dann zur 'Glücksanalyse', um deinen persönlichen <strong>Glückswert</strong> zu sehen.",
    howtoStep4Title: "💾 Sichere deinen Verlauf",
    howtoStep4Text:
      "Deine Daten sind wertvoll. Nutze die 'Daten exportieren'-Funktion in den Einstellungen (⚙️), um ein manuelles Backup zu erstellen. Für müheloses Synchronisieren über Geräte hinweg, kannst du **optional auch dein Google Drive-Konto** für sichere Cloud-Speicherungen verbinden.",
    howtoEnjoy: "Viel Glück bei den Gebeten, Reisender!",
    howtoButton: "Los geht's!",
    versionInfo: "Unterstützt aktuell Genshin Impact Version {version}",
    changelog: "Änderungsprotokoll",
    changelogTitle: "Was ist neu",
    changelogRefreshTitle: "Update-Hinweis",
    changelogRefreshDesktop:
      "Um sicherzustellen, dass du die neueste Version hast, führe bitte einen Hard-Refresh durch (Strg + F5).",
    changelogRefreshMobile:
      "Auf Mobilgeräten musst du eventuell den Browser-Cache für diese Seite in den Einstellungen leeren.",
    backupReminderTitle: "WICHTIG: Sichere deine Daten!",
    backupReminderText:
      "Bevor du einen Hard-Refresh oder Cache clear durchführst, benutze bitte die 'Daten exportieren'-Funktion in den Einstellungen (⚙️-Symbol), um eine Sicherungsdatei deines Gebetsverlaufs zu erstellen. Dies verhindert jegliches Risiko eines Datenverlusts.",
    chartPityHistory: "Pity-Verlauf",
    chartDistribution: "Verteilung",
    chartTypeRatio: "Typen-Verhältnis",
    createShareImage: "Teilbares Bild erstellen",
    shareTitle: "Teile deine Statistiken",
    shareLoader: "Bild wird generiert, bitte warten...",
    shareDownload: "Bild herunterladen",
    luckiest4star: "Bester 4★ Zug:",
    unluckiest4star: "Schlechtester 4★ Zug:",
    ratio4star: "4★ Verhältnis (Fig/Waffe):",
    rateUpLabel: "Rate Up 50%",
    weaponRateUpLabel: "Rate Up 75%",
    banner_ineffa: "Astrale Aktivierung",
    banner_citlali: "Flüstern der Sternennacht",
    banner_chasca: "Piercing Shot's Crimson Wake",
    banner_mualani: "Sharktacular Surfari",
    banner_flins: "The Lone Light Knocks at Night",
    banner_yelan: "Discerner of Enigmas",
    banner_lauma: "Moonsong of the Groves",
    banner_nahida: "Moongrass' Enlightenment",
    banner_nefer: "Temptation of the Crimson Sands",
    banner_furina: "Chanson of Many Waters",
    banner_arlecchino: "The Hearth's Ashen Shadow",
    banner_zhongli: "Gentry of Hermitage",
    banner_durin: "Rubedo, of White Stone Born",
    banner_venti: "Ballad in Goblets",
    banner_varesa: "Cornucopia of Contention",
    banner_xilonen: "Forgefire's Blessing",
    banner_zibai: "Harmonius Abundance",
    banner_columbina: "Somnias a Luna",
    banner_neuvillette: "Decree of the Deeps",
    banner_skirk: "Void Star's Advent",
    banner_escoffier: "La Chanson Cerise",
    banner_varka: "The Northerly Wind's Song of Triumph",
    banner_linnea: "Ya-hoho! Compendium",
    banner_nicole: "",
    banner_lohen: "",
    banner_mauvika: "",
    banner_prune: "",
    characterBannerPhase1: (name) => `Aktionsgebet (${name})`,
    characterBannerPhase2: (name) => `Aktionsgebet (${name})`,
    nextBannerButton: "Nächste Banner",
    upcomingBannersTitle: "Kommende Banner",
    bannerEndsIn: "Endet in:",
    bannerEnded: "Banner beendet",
    sectionTitle: "Dein ultimativer Genshin Impact Pity Tracker & Gebetszähler",
    whatIsPityTitle: "Was ist Pity? Dein Guide zum Genshin Gebetszähler",
    whatIsPityText1:
      'In Genshin Impact ist das "Pity-System" eine entscheidende Gacha-Mechanik, die dir garantiert, 4- und 5-Sterne-Gegenstände nach einer bestimmten Anzahl von Gebeten zu erhalten. Jedes Mal, wenn du betest und keinen hochrangigen Gegenstand bekommst, steigt dein "Pity". Dieses Tool fungiert als dein persönlicher <strong>Genshin Impact Gebetszähler</strong> und automatisiert alle komplexen Regeln für dich.',
    whatIsPityText2:
      'Der Pity-Zähler wird auf Null zurückgesetzt, sobald du einen Gegenstand der entsprechenden Seltenheit erhältst. Bei 5-Sterne-Figuren erfolgt ein garantierter Zug bei 90 Gebeten (mit einer "Soft Pity"-Phase ab ca. 74), beim Waffenbanner sind es 80 Gebete. Bei 4-Sterne-Gegenständen liegt das Maximum bei 10. Verpasse nie wieder einen garantierten 5-Sterne-Zug, indem du diesen präzisen <strong>Genshin Pity-Zähler</strong> für jedes einzelne Gebet nutzt!',
    pityGuideExtra:
      'Dieser <strong>Genshin Gebets-Tracker</strong> hilft dir, diesen Prozess lückenlos zu dokumentieren. Jedes einzelne Gebet wird gezählt, sodass du genau weißt, wann du in die "Soft Pity"-Zone kommst – den Bereich, in dem die Wahrscheinlichkeit auf einen 5-Sterne-Zug signifikant ansteigt. Vergiss ungenaue Schätzungen; mit diesem Tool hast du einen präzisen <strong>Genshin Impact Zähler</strong> für deine Gacha-Reise.',
    howToUseTitle: "Anleitung für diesen Genshin Gebets-Tracker",
    howToUseStep1:
      "<strong>1. Ressourcen einrichten:</strong> Navigiere zum Tab 'Ressourcen & Planer'. Gib dein aktuelles Urgestein, Schicksal und Sternenglanz ein, um einen klaren Überblick über deine verfügbaren Gebete zu erhalten.",
    howToUseStep2:
      "<strong>2. Pity-Stand synchronisieren:</strong> Wenn du neu hier bist, schaue in deinen Gebetsverlauf im Spiel und nutze die \"Pity setzen\"-Felder auf jedem Banner im 'Banner'-Tab, um deinen Fortschritt schnell zu synchronisieren. Diese einmalige Einrichtung stellt sicher, dass dein <strong>Pity-Zähler</strong> korrekt startet.",
    howToUseStep3:
      "<strong>3. Gebete loggen:</strong> Nutze die '+1' oder '10er-Pull'-Buttons. Wenn du einen 4- oder 5-Sterne-Gegenstand erhältst, verwende die dedizierten 'Loggen'-Buttons. Das Tool setzt deine Pity automatisch zurück und fügt das neue Item deiner persönlichen Sammlung hinzu.",
    howToUseStep4:
      "<strong>4. Mehrere Accounts verwalten:</strong> Gehe zu Einstellungen (⚙️) -> Datenverwaltung. Hier kannst du mehrere Accounts hinzufügen, umbenennen und zwischen ihnen wechseln. Jeder Account hat komplett getrennte Daten, und ein Klick auf 'Daten exportieren' oder 'In Drive speichern' sichert alle auf einmal.",
    howToUseStep5:
      "<strong>5. Deine Sammlung verwalten:</strong> Gehe zum 'Profil'-Tab und wähle 'Meine Sammlung'. Hier siehst du jede Figur und Waffe, die du gezogen hast. Aktiviere ausstehende Sternbilder für Figuren oder verfeinere doppelte Waffen mit einem Klick.",
    howToUseStep6:
      "<strong>6. Dein Gacha-Glück analysieren & vorausplanen:</strong> Wechsle im 'Profil'-Tab zu 'Glücksanalyse', um deinen persönlichen Glückswert und detaillierte Statistiken zu sehen. Nutze dann den 'Ziel-Planer' im 'Ressourcen'-Tab, um zu berechnen, wie lange es bis zu deinem nächsten 5-Sterne-Wunsch dauert.",
    bannerRulesTitle: "Genshin Banner-Regeln erklärt",
    bannerRulesIntro:
      "Das Pity-System in Genshin Impact hat für jeden Bannertyp spezielle Regeln. Unser <strong>Pity-Zähler</strong> berücksichtigt diese automatisch, aber hier ist eine detaillierte Erklärung:",
    bannerRulesCharTitle: "Figurenbanner (Das 50/50-System erklärt):",
    bannerRulesCharText:
      "Wenn du eine 5-Sterne-Figur ziehst, besteht eine 50%ige Chance, dass es die Aktionsfigur ist. Verlierst du diese '50/50'-Wette und erhältst eine Standardfigur (wie Diluc, Jean etc.), ist dein Schicksal besiegelt: Dein nächster 5-Sterne-Zug auf einem Aktionsfigurenbanner ist zu <strong>100% garantiert</strong> die jeweilige Aktionsfigur. Dies ist die wichtigste Mechanik, die unser <strong>Genshin Tracker</strong> für dich verwaltet.",
    bannerRulesWeaponTitle: "Waffenbanner (Göttlicher Kurs erklärt):",
    bannerRulesWeaponText:
      "Dieses Banner bietet eine 75%ige Chance, eine der beiden 5-Sterne-Aktionswaffen zu erhalten. Um eine bestimmte Waffe gezielt zu erhalten, legst du mit 'Göttlicher Kurs' einen Kurs fest. Erhältst du eine 5-Sterne-Waffe, die nicht deine gewählte ist, bekommst du <strong>1 Schicksalspunkt</strong>. Mit 1 Schicksalspunkt ist deine nächste 5-Sterne-Waffe <strong>zu 100% garantiert</strong> die, auf die du den Kurs festgelegt hast.",
    bannerRulesChronicledTitle:
      "Kronikgebet (Garantie auf ausgewählten Gegenstand):",
    bannerRulesChronicledText:
      "Dieses spezielle Banner lässt dich einen Kurs auf eine 5-Sterne-Figur ODER eine Waffe aus einem großen Pool festlegen. Wenn du einen 5-Sterne-Gegenstand ziehst, der nicht deine Wahl ist, erhältst du <strong>1 Schicksalspunkt</strong>, und der nächste 5-Sterne-Zug ist <strong>garantiert</strong> dein Kurs-Item. Die Pity wird bei Erhalt eines beliebigen 5-Sterne-Gegenstands zurückgesetzt.",
    wikiTitle: "Integriertes Teyvat-Wiki für Builds & Materialien",
    wikiIntro:
      "Dieser Tracker ist mehr als nur ein Zähler – er ist dein strategischer Begleiter. Klicke auf das Porträt einer Figur auf den Bannern, in deinem Verlauf oder direkt aus deiner <strong>Sammlung</strong>, um ein detailliertes Informationsfenster zu öffnen.",
    wikiOutro:
      "Dieses Feature macht die Planung für deine nächsten Wunsch-Charaktere einfacher als je zuvor und ist ein einzigartiges Merkmal dieses <strong>Genshin Impact Gebetszählers</strong>.",
    privacyTitle: "Unser Datenschutz-Versprechen: 100% Lokal, 100% Deins",
    privacyText1:
      "Dieser Tracker basiert auf einer einfachen Philosophie: Deine Daten gehören dir. <strong>Es gibt keinen Server. Es gibt keine Konten.</strong> Nichts, was du eingibst, verlässt jemals dein Gerät. Wir können weder deine Pity, noch deinen Gebetsverlauf oder andere Informationen einsehen. Dieses Tool funktioniert komplett offline.",
    privacyText2:
      'Alle Daten werden im "Local Storage" deines Browsers gespeichert. Das macht die App extrem schnell, bedeutet aber auch, dass das Leeren deines Browser-Caches deine Daten dauerhaft löscht. <strong>Bitte nutze regelmäßig die "Daten exportieren"-Funktion in den Einstellungen, um Backups zu erstellen!</strong>',
    privacyText3:
      "Zur Bequemlichkeit hast du die <strong>optionale</strong> Möglichkeit, deine Daten über dein eigenes Google Drive-Konto zu synchronisieren. Selbst dann erhält diese App nur die Berechtigung, auf die eine Datei zuzugreifen, die sie selbst erstellt. Du behältst immer die volle Kontrolle.",
    privacyText4:
      "Keine Werbung. Keine Cookie-Banner. Kein Tracking. Nur ein Tool, das von einem Fan für Fans entwickelt wurde.",
    settingsTabGeneral: "Allgemein",
    settingsTabData: "Daten",
    dataManagementDesc:
      "Speichere deinen Gebetsverlauf in einer Datei oder importiere ein früheres Backup.",
    settingsTabAchievements: "Erfolge",
    tabProfile: "Profil",
    tabBanners: "Banner",
    profileTitle: "Analyse deines Reisenden-Glücks",
    profileNoData: "Logge mehr Gebete, um deine Profil-Analyse freizuschalten!",
    profileLuckScore: "Glückswert",
    profileAvgPity5: "Durchschn. 5★ Pity",
    profileWinRate5050: "50/50-Gewinnrate",
    profileElementalAffinity: "Elementare Affinität",
    profileFortuneCookie: "Einblick des Glückskekses",
    profileWeaponAffinity: "Waffen-Affinität",
    profileAvgPity4: "Durchschn. 4★ Pity",
    background: "Hintergrund",
    bgIcons: "Icons",
    bgStars: "Sterne",
    bgOff: "Aus",
    minigameRestart: "Spiel neu starten",
    minigameResetHighscore: "Highscore zurücksetzen",
    confirmResetHighscoreText:
      "Bist du sicher, dass du deinen Highscore zurücksetzen möchtest? Dies kann nicht rückgängig gemacht werden.",
    audioSettings: "Audio-Einstellungen",
    confirmDeleteInventoryChar: (name) =>
      `Bist du sicher, dass du ${name} permanent aus deiner Sammlung entfernen möchtest? Dies kann nicht rückgängig gemacht werden.`,
    confirmDeleteInventoryWeapon: (name) =>
      `Bist du sicher, dass du diese Kopie von ${name} permanent aus deiner Sammlung entfernen möchtest? Dies kann nicht rückgängig gemacht werden.`,
    tabGuide: "Anleitung",
    googleDriveSyncDesc:
      "Für müheloses Synchronisieren über Geräte hinweg und sichere Cloud-Backups kannst du optional dein Google-Konto verbinden. Die App erhält immer nur die Berechtigung, auf ihre eigene Datendatei zuzugreifen.",
    crTitle: "Gefangener Glanz: Dein Pechsträhnen-Schutz",
    crIntro:
      '"Gefangener Glanz" (Capturing Radiance, CR) ist ein wohlwollendes, verstecktes System von HoYoverse, das extreme Pechsträhnen nach mehreren verlorenen 50/50-Würfen verhindern soll. Es ist eine besondere, leuchtende Gebets-Animation, die einen "erzwungenen" Sieg anzeigt. Dieser Tracker hilft dir, den unsichtbaren Zähler hinter diesem Sicherheitsnetz, den <strong>C-Status</strong>, zu überwachen.',
    crHowItWorksTitle: "Wie der C-Status-Zähler funktioniert:",
    crHowItWorksText:
      "Der C-Status ändert sich mit deinen 50/50-Ergebnissen. Ein verlorenes 50/50 erhöht ihn um 1 (bis max. 3). Ein normaler 50/50-Sieg verringert ihn um 1. Ein Sieg mit 'Gefangener Glanz' setzt ihn direkt auf 1 zurück.",
    crStateMeaningsTitle: "Was der C-Status in deinem Tracker bedeutet:",
    crState01:
      "<strong>C-Status 0 oder 1:</strong> Dein nächstes 50/50 ist ein normaler Wurf.",
    crState2:
      "<strong>C-Status 2:</strong> Du hast eine leicht erhöhte Chance, dass dein nächster 50/50-Sieg ein 'Gefangener Glanz' ist.",
    crState3:
      "<strong>C-Status 3:</strong> Dein nächster 50/50 ist <strong>ein garantierter GEWINN</strong> und wird die 'Gefangener Glanz'-Animation auslösen, selbst wenn du eigentlich verloren hättest! Das ist der ultimative Pechschutz.",
    crHowToUseTrackerTitle: "Wie der Tracker dir dabei hilft:",
    crHowToUseTrackerText:
      "Zu Beginn schätzt der Tracker deinen C-Status basierend auf deinem Verlauf (angezeigt durch ein \"?\"). Nachdem du ein 50/50 gewonnen hast, fragt der Tracker, ob es ein Sieg mit 'Gefangener Glanz' war. Deine Antwort kalibriert den C-Status präzise, entfernt das Fragezeichen und macht alle zukünftigen Vorhersagen genau. Du kannst deinen Status auch manuell in den Einstellungen festlegen, wenn du ihn bereits kennst.",
    manageGoals: "Ziele verwalten",
    saveGoals: "Ziele speichern & neu berechnen",
    plannerGuideTitle: "Wie die Ziel-Planer-Szenarien berechnet werden",
    plannerGuideIntro:
      "Der Ziel-Planer liefert drei verschiedene Schätzungen, um dir bei der Planung deiner Gebete zu helfen. Das bedeutet jedes Szenario:",
    plannerGuideLuckyTitle: "GLÜCKSFALL",
    plannerGuideLuckyText:
      "Dein Traum-Szenario. Es wird angenommen, dass du jedes 50/50 gewinnst und deinen 5-Sterne-Charakter oder deine Waffe sehr früh erhältst, weit vor Soft Pity (bei durchschnittlich 35 Gebeten). Möglich, aber verlass dich nicht darauf!",
    plannerGuideAverageTitle: "DURCHSCHNITTSFALL",
    plannerGuideAverageText:
      "Dies ist die realistischste Schätzung, basierend auf großen Datenmengen der Community. Sie verwendet die echten statistischen Durchschnittswerte:",
    plannerGuideAveragePity:
      "Ein garantierter 5-Sterne dauert im Schnitt etwa <strong>63 Gebete</strong> (wegen Soft Pity).",
    plannerGuideAverage5050:
      "Ein nicht-garantierter Charakter dauert im Schnitt etwa <strong>93 Gebete</strong> (diese Zahl beinhaltet bereits die statistische Wahrscheinlichkeit, das 50/50 zu verlieren).",
    plannerGuideAverageCR:
      "Dein aktueller <strong>Gefangener Glanz (C-Status)</strong> wird ebenfalls berücksichtigt. Wenn du bei C-Status 3 bist, weiß der Planer, dass dein nächstes 50/50 ein garantierter Gewinn ist und passt die Berechnung an!",
    plannerGuideWorstTitle: "SCHLIMMSTER FALL",
    plannerGuideWorstText:
      "Das ist dein Sicherheitsnetz. Es wird angenommen, dass du jede einzelne Chance verlierst:",
    plannerGuideWorstPity:
      "Du ziehst jedes Mal bis zum Hard Pity (90 für Charaktere, 80 für Waffen).",
    plannerGuideWorst5050:
      "Du verlierst jedes 50/50 und jedes 75/25, was einen zweiten Pull für die Garantie erfordert.",
    plannerGuideWorstWhy:
      "<strong>Warum ist die Zahl nicht rund?</strong> Die Berechnung zieht deinen aktuellen Pity-Fortschritt von den Kosten des <em>allersten</em> Zugs in der Sequenz ab. Du erhältst also einen 'Rabatt' für die Gebete, die du bereits investiert hast.",
    plannerInventoryNote:
      "Hinweis: Die Berechnung berücksichtigt deine bereits vorhandenen Sternbilder und Verfeinerungsstufen aus 'Meine Sammlung'.",
    chronicledInactiveTitle: "Derzeit nicht verfügbar",
    chronicledInactiveText:
      "Das Kronikgebet ist in der aktuellen Phase nicht aktiv.",
    starglitterEquivalent: "Entspricht {count} Gebeten",
    genesisEquivalent: "Entspricht {count} Gebeten",
    primogemEquivalent: "Entspricht {count} Gebeten",
  },
};
